export default __webpack_public_path__ + "static/media/customurl.c5f38e44.svg";